import { render, staticRenderFns } from "./ApplyForArchival.vue?vue&type=template&id=d347a164"
import script from "./ApplyForArchival.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyForArchival.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports